import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';

export default function GatewayHighlight() {
  return (
    <Container sx={{ py: 8, color: 'common.white' }}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={5}>
          <Typography variant="h3" component="h2" color="secondary.main" gutterBottom>
            GATEWAY FREE AI ASSESSMENT SERVICE
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography variant="body1" paragraph>
            In a 60-minute session, we walk through your AI readiness and outline practical next steps toward intelligent automation.
          </Typography>
          <Box component="ul" sx={{ pl: 4, m: 0 }}>
            <Typography component="li" variant="body1" sx={{ mb: 1 }}>
              a clear report revealing your organisation's AI readiness
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 1 }}>
              a high-impact opportunity blueprint tailored to your goals
            </Typography>
            <Typography component="li" variant="body1">
              a 'gap alert' that surfaces risks and inefficiencies
            </Typography>
          </Box>
          <Typography variant="body1" paragraph>
            Our team analyses your survey in advance and our founder leads the session to explore your bespoke roadmap.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
